import apiFetch from "@/app/auth/apiFetch";

const API_URL = import.meta.env.VITE_API_URL;

export interface SchoolIndustry {
  id: number;
  name: string;
  external_ref: string;
}

export interface SchoolLocation {
  country?: string | null;
  geographic_area?: string | null;
  city?: string | null;
  postal_code?: string | null;
  line1?: string | null;
  line2?: string | null;
  is_headquarters?: boolean;
}

export interface SchoolListItem {
  id: number;
  name: string;
  external_ref: string;
  profile_url?: string | null;
  description?: string | null;
  location?: string | null;
  website_url?: string | null;
  follower_count?: number | null;
  staff_count?: number | null;
  staff_count_range_start?: number | null;
  staff_count_range_end?: number | null;
  specialties?: string[] | null;
  founded_year?: number | null;
  industries?: SchoolIndustry[] | null;
  locations?: SchoolLocation[] | null;
  crunchbase_url?: string | null;
  num_funding_rounds?: number | null;
  funding_rounds?: {
    id: number;
    funding_type?: string | null;
    money_raised_amount?: number | null;
    money_raised_currency?: string | null;
    announced_on?: string | null;
    num_other_investors?: number | null;
    funding_round_crunchbase_url?: string | null;
    investors: { name: string; crunchbase_url?: string | null }[];
  }[] | null;
  created?: string | null;
  updated?: string | null;
}

export interface PaginatedSchoolsResponse {
  items: SchoolListItem[];
  total: number;
  page: number;
  size: number;
  pages: number;
}

export async function enqueueSchoolEnrichment(navigate, schoolId: number) {
  const url = `${API_URL}/schools/${schoolId}/enqueue-enrichment`;
  const res = await apiFetch(url, { method: "POST" }, navigate);
  if (!res?.ok) throw new Error("Erreur lors de la mise en file d'enrichissement");
  return res.json() as Promise<{ status: string; school_id: number }>;
}

export async function getSchoolDetail(navigate, schoolId: number) {
  const url = `${API_URL}/schools/${schoolId}`;
  const res = await apiFetch(url, { method: "GET" }, navigate);
  if (!res?.ok) throw new Error("Erreur lors du chargement de l'école");
  return res.json() as Promise<SchoolListItem>;
}

export async function listSchools(
  navigate: NavigateFunction,
  params?: { page?: number; size?: number; sort_by?: string; sort_order?: string }
) {
  const q = new URLSearchParams();
  q.set("page", String(params?.page ?? 1));
  q.set("size", String(params?.size ?? 25));
  if (params?.sort_by) q.set("sort_by", params.sort_by);
  if (params?.sort_order) q.set("sort_order", params.sort_order);
  const url = `${API_URL}/schools?${q.toString()}`;
  const res = await apiFetch(url, { method: "GET" }, navigate);
  if (!res?.ok) throw new Error("Erreur lors du chargement des écoles");
  return res.json() as Promise<PaginatedSchoolsResponse>;
}
